export function stickySidebar(customMedia) {
  var contentHeight = 0,
    currentWidth,
    newWidth,
    mediaPoint = customMedia || 992,
    sectionContentBlog = $(".js-scroll-container"),
    paddingBottom = 0;

  if (sectionContentBlog.hasClass("js-scroll-container_narrow")) {
    mediaPoint = 919;
  }

  function getDynamicOffset() {
    const header = document.querySelector(".site-header");
    const banner = document.querySelector(".bf-banner");

    const headerHeight = header ? header.offsetHeight : 0;
    const bannerHeight = banner ? banner.offsetHeight : 0;

    return headerHeight + bannerHeight + 20;
  }

  function setContainersHeight() {
    let sidebarHeight = 0;
    $(".js-fixed-inner").each(function () {
      const thisHeight = $(this).outerHeight();
      if (thisHeight > sidebarHeight) sidebarHeight = thisHeight;
    });
    sectionContentBlog.css("min-height", sidebarHeight);
    let refreshedHeight = sectionContentBlog.height() + paddingBottom;
    if (refreshedHeight !== contentHeight) {
      contentHeight = refreshedHeight;
      $(".js-fixed-col").css("height", contentHeight);
      $(document.body).trigger("sticky_kit:recalc");
    }
  }

  function launchStickySidebar() {
    const stickyOffsetTop = getDynamicOffset();
    $(".js-fixed-col").css("height", contentHeight);

    $(".js-inner-scrolling-stop .js-fixed-inner").stick_in_parent({
      offset_top: stickyOffsetTop,
      inner_scrolling: false,
    });

    $(".js-fixed-inner").stick_in_parent({
      offset_top: stickyOffsetTop,
      inner_scrolling: true,
    });
  }

  $(window).on("resize", function () {
    setContainersHeight();
    newWidth = window.innerWidth;
    if (newWidth > mediaPoint && currentWidth <= mediaPoint) {
      launchStickySidebar();
    } else if (newWidth <= mediaPoint && currentWidth > mediaPoint) {
      $(".js-fixed-inner").trigger("sticky_kit:detach");
      $(".js-fixed-col").removeAttr("style");
    }
    currentWidth = newWidth;
  });

  $(document).ready(function () {
    setContainersHeight();
    currentWidth = window.innerWidth;

    if (currentWidth > mediaPoint) {
      launchStickySidebar();
    }

    $(window).on("scroll", function () {
      setContainersHeight();
    });

    const banner = document.querySelector(".bf-banner");
    if (banner) {
      const observer = new MutationObserver(() => {
        $(window).trigger("resize");
      });
      observer.observe(banner, { childList: true, subtree: true });
    }

    $(".js-fixed-col .lazy").on("load error", function () {
      $(window).trigger("resize");
    });
  });

  $(".js-collapse").on("shown.bs.collapse hidden.bs.collapse", function () {
    $(window).trigger("resize");
  });
}
